export class MovimientoReembolsoCreateDto {
    constructor() {
        this.idPaciente = null;
        this.idArea = null;
        this.idClinica = null;
        this.idEmpleadoSolicito = null;
        this.idTipoMovimiento = null;
        this.monto = null;
        this.idRecibo = null;
        this.archivos = [];
        this.tratamientos = [];
        this.cuestionarioLegal = {};
    }
}
